/* Motor das ofertas progressivas do carrinho.
   Ver snippets/carrinho-progresso.liquid.

   REPLICA o comportamento da app UpCart, com as regras todas:
   - cada patamar tem VALOR e NÚMERO MÍNIMO DE PRODUTOS distintos;
   - o total elegível EXCLUI os produtos de uma colecção (as Promoções);
   - só há UM presente de cada vez: ao subir de patamar o anterior sai;
   - a oferta entra ao preço normal e é um desconto automático da Shopify que a
     põe a 0 — por isso o preço real fica no catálogo e é o checkout a validar.

   🚨 O QUE CORRIGE face à app: a app duplicava o presente ao mudar de patamar,
   e uma das linhas ficava SEM desconto, ou seja o cliente pagava-a. Aqui, antes
   de adicionar seja o que for, colapsam-se as linhas de oferta repetidas e
   removem-se as que não pertencem ao patamar em vigor. A adição só acontece
   depois de o carrinho estar limpo, e nunca mais do que uma vez (`aTratar`).

   ⚠️ A GAVETA É RECONSTRUÍDA A CADA ALTERAÇÃO. O `renderHelperCart` do tema
   substitui o `innerHTML` do `#AjaxCartForm`, e a barra vive lá dentro: o nó
   desaparece e nasce outro igual ao que o Liquid escreveu. Daí as duas regras
   deste ficheiro:
     1. nunca guardar referências ao DOM entre passagens, ir buscá-las sempre;
     2. redesenhar quando o nó for trocado, o que se percebe comparando-o com o
        último que foi desenhado (as escritas próprias não trocam o nó, por isso
        isto não entra em ciclo).
   O `<script>` que carrega este ficheiro está dentro dessa mesma zona e, vindo
   por `innerHTML`, o browser não volta a executá-lo. É por isso que tudo tem de
   aguentar-se numa única passagem.

   14/10/2026, pedido do Marco: a decisão final é do cliente. A linha da oferta
   tem um «Remover» (`[data-js-oferta-remover]`). Ao carregar, guarda-se a
   RECUSA dessa oferta para este carrinho e o motor deixa de a acrescentar. A
   barra continua a mostrar o patamar alcançado e diz que a oferta foi removida,
   com «Voltar a adicionar». A recusa vale só para essa oferta: ao chegar a um
   patamar mais alto, entra a oferta desse patamar.
*/
(function () {
  if (window.__carrinhoProgressoLigado) return;
  window.__carrinhoProgressoLigado = true;

  var MARCA = '_oferta_patamar';
  var aTratar = false;
  var excluidos = null;
  var ultimoNo = null;
  var ultimaBase = null;
  var temporizador = null;
  var insistencias = 0;
  var faltaSoProdutos = false;

  function caixa() {
    return document.querySelector('[data-js-degraus]');
  }

  /* Os degraus vêm do `data-degraus` do nó em uso. Relê-se a cada passagem
     porque o nó é outro de cada vez que a gaveta se refaz. */
  function lerDegraus(c) {
    return (c.dataset.degraus || '').split('|').filter(Boolean).map(function (d) {
      var p = d.split('~');
      return {
        valor: parseInt(p[0], 10),
        rotulo: p[1],
        variante: p[2] || null,
        minProdutos: parseInt(p[3], 10) || 0,
        /* A oferta do escalão não tem stock. Se ainda assim houver `variante`,
           é o produto suplente das definições; se não houver, o escalão fica
           sem oferta e vale a do escalão anterior (ver ofertaDevida). */
        esgotado: p[4] === '1',
        suplente: p[5] === '1'
      };
    }).sort(function (a, b) { return a.valor - b.valor; });
  }

  function moeda(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'pt-PT',
        { style: 'currency', currency: (window.Shopify && Shopify.currency) ? Shopify.currency.active : 'EUR' })
        .format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + '€'; }
  }

  /* Ids dos produtos a EXCLUIR do total. Lidos uma vez e guardados na sessão:
     são dezenas de produtos e não mudam a meio de uma visita. */
  function carregaExcluidos(handle) {
    if (!handle) return Promise.resolve([]);
    if (excluidos) return Promise.resolve(excluidos);
    var chave = 'cp-excl-' + handle;
    try {
      var guardado = sessionStorage.getItem(chave);
      if (guardado) { excluidos = JSON.parse(guardado); return Promise.resolve(excluidos); }
    } catch (e) {}
    return fetch('/collections/' + handle + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        excluidos = (j.products || []).map(function (p) { return p.id; });
        try { sessionStorage.setItem(chave, JSON.stringify(excluidos)); } catch (e) {}
        return excluidos;
      })
      .catch(function () { excluidos = []; return excluidos; });
  }

  function eOferta(item) {
    return !!(item.properties && item.properties[MARCA]);
  }

  /* Base de cálculo: só linhas PAGAS e fora da colecção excluída.

     O «no mínimo N produtos» dos patamares conta-se de uma de duas maneiras,
     escolhida nas definições do tema. A app UpCart escrevia «com no mínimo 3
     produtos» sem dizer qual das duas era:
       distintos  → três ARTIGOS diferentes (três unidades do mesmo não chegam)
       unidades   → três unidades, ainda que do mesmo artigo
  */
  function base(carrinho, fora, modo) {
    var total = 0, distintos = {}, unidades = 0;
    (carrinho.items || []).forEach(function (item) {
      if (eOferta(item)) return;
      if (fora.indexOf(item.product_id) !== -1) return;
      total += item.final_line_price;
      distintos[item.product_id] = true;
      unidades += item.quantity;
    });
    var quantos = (modo === 'unidades') ? unidades : Object.keys(distintos).length;
    return { total: total, produtos: quantos, cupao: temCupao(carrinho), carrinho: carrinho.token || '' };
  }

  function desbloqueado(d, b) {
    return b.total >= d.valor && b.produtos >= d.minProdutos;
  }

  function desenha(b) {
    var c = caixa();
    if (!c || !b) return;

    var degraus = lerDegraus(c);
    /* 14/10/2026, pedido do Marco: com cupão as ofertas não se acumulam, por
       isso a barra fica só com o envio grátis (o degrau sem produto que não está
       esgotado). Os presentes deixam de aparecer como coisa por ganhar. */
    if (b.cupao) {
      degraus = degraus.filter(function (d) { return !d.variante && !d.esgotado; });
    }
    if (!degraus.length) return;

    var texto = c.querySelector('[data-js-degraus-texto]');
    var cheio = c.querySelector('[data-js-degraus-cheio]');
    var pontos = c.querySelector('[data-js-degraus-pontos]');
    var rotulos = c.querySelector('[data-js-degraus-rotulos]');
    if (!texto || !cheio || !pontos || !rotulos) return;

    /* Posição do degrau i na barra: espaços iguais, o último aos 100%. */
    function posicao(i) {
      return ((i + 1) / degraus.length) * 100;
    }

    /* Percentagem de enchimento para um total: linear dentro de cada vão. */
    function enchimento(total) {
      var valorAnterior = 0;
      var pctAnterior = 0;
      for (var j = 0; j < degraus.length; j++) {
        var pctPonto = posicao(j);
        if (total < degraus[j].valor) {
          var vaoValor = degraus[j].valor - valorAnterior;
          if (vaoValor <= 0) return pctPonto;
          return pctAnterior + ((total - valorAnterior) / vaoValor) * (pctPonto - pctAnterior);
        }
        valorAnterior = degraus[j].valor;
        pctAnterior = pctPonto;
      }
      return 100;
    }
    var tplEnvio = c.querySelector('[data-js-icone-envio]');
    var tplPresente = c.querySelector('[data-js-icone-presente]');
    var tplFeito = c.querySelector('[data-js-icone-feito]');

    var proximo = null;
    for (var i = 0; i < degraus.length; i++) {
      if (!desbloqueado(degraus[i], b)) { proximo = degraus[i]; break; }
    }

    /* Os textos vêm das definições do tema, não daqui: a loja tem três idiomas
       e texto escrito em JavaScript não passa pelo editor de traduções. */
    if (b.cupao) {
      faltaSoProdutos = false;
      texto.textContent = c.dataset.textoCupao || 'Com um cupão aplicado, as ofertas dos patamares não se acumulam.';
    } else if (proximo) {
      if (b.total < proximo.valor) {
        faltaSoProdutos = false;
        texto.innerHTML = (c.dataset.textoValor || 'Faltam {AMOUNT} para desbloquear a próxima oferta')
          .replace('{AMOUNT}', '<b>' + moeda(proximo.valor - b.total) + '</b>');
      } else {
        /* Singular e plural são duas frases inteiras e não uma frase com um
           número colado: o que falta é um produto DIFERENTE, e «Falta 1
           produto» lia-se como se bastasse carregar no «+». As duas frases
           vivem nas definições do tema, para o editor de traduções lhes chegar. */
        faltaSoProdutos = true;
        var faltam = proximo.minProdutos - b.produtos;
        if (faltam === 1) {
          texto.innerHTML = c.dataset.textoProduto || 'Falta 1 produto diferente para desbloquear a próxima oferta';
        } else {
          texto.innerHTML = (c.dataset.textoProdutos || 'Faltam {COUNT} produtos diferentes para desbloquear a próxima oferta')
            .replace('{COUNT}', '<b>' + faltam + '</b>');
        }
      }
    } else {
      faltaSoProdutos = false;
      /* Tudo desbloqueado, mas a oferta do último escalão pode estar esgotada
         e sem suplente: diz-se isso em vez de «desbloqueou tudo», e se houver
         uma oferta de um escalão abaixo, diz-se que é essa que segue. */
      var topo = degraus[degraus.length - 1];
      if (topo.esgotado && !topo.variante) {
        texto.textContent = ofertaDevida(degraus, b)
          ? (c.dataset.textoEsgotadoAnterior || 'A oferta deste patamar esgotou. Recebe a do patamar anterior.')
          : (c.dataset.textoEsgotadoNada || 'A oferta deste patamar esgotou.');
      } else {
        texto.textContent = c.dataset.textoCompleto || 'Desbloqueou todas as vantagens!';
      }
    }

    /* Oferta removida pelo cliente: uma linha por baixo do texto, com a
       ligação para a repor. O nó é criado aqui porque a gaveta refaz-se. */
    var alcancado = b.cupao ? null : patamarAlcancado(degraus, b);
    var linhaRecusa = c.querySelector('[data-js-degraus-recusa]');
    if (alcancado && recusada(b, alcancado.variante)) {
      if (!linhaRecusa) {
        linhaRecusa = document.createElement('p');
        linhaRecusa.className = 'cart-degraus__recusa';
        linhaRecusa.setAttribute('data-js-degraus-recusa', '');
        texto.insertAdjacentElement('afterend', linhaRecusa);
      }
      linhaRecusa.innerHTML = '';
      linhaRecusa.appendChild(document.createTextNode((c.dataset.textoRecusada || 'Removeu a oferta deste patamar.') + ' '));
      var repor = document.createElement('button');
      repor.type = 'button';
      repor.className = 'cart-degraus__repor';
      repor.setAttribute('data-js-oferta-repor', '');
      repor.textContent = c.dataset.textoRepor || 'Voltar a adicionar';
      linhaRecusa.appendChild(repor);
    } else if (linhaRecusa) {
      linhaRecusa.remove();
    }

    aplicaTituloSugestoes();

    /* O enchimento nunca passa o próximo ponto por acender. Enchia só com o
       valor, e num carrinho caro com poucos artigos distintos a barra ia quase
       ao fim com duas bolinhas apagadas: dizia «desbloqueaste tudo» e a frase
       por cima dizia «falta 1 produto». Assim pára encostada ao degrau que
       falta, que é a leitura certa. */
    /* 24/09/2026: os pontos passaram a ficar a DISTÂNCIAS IGUAIS (um quarto da
       barra cada, com 4 degraus), a pedido dela: «gostava que houvesse sintonia
       nos espaços entre si». Antes cada ponto ficava na percentagem do seu valor
       (30 € de 109 = 27%) e o desenho parecia desproporcional. O enchimento
       passa a ser calculado troço a troço: dentro de cada vão a barra anda em
       proporção ao que falta para esse degrau, e por isso continua a bater
       certo com o ponto quando o valor é atingido. */
    var limite = proximo ? posicao(degraus.indexOf(proximo)) : 100;
    cheio.style.width = Math.min(limite, enchimento(b.total)) + '%';

    pontos.innerHTML = '';
    rotulos.innerHTML = '';

    /* Largura dos rótulos, em PERCENTAGEM da barra: um vão entre pontos menos
       uma folga. A gaveta é mais estreita no telemóvel e uma largura fixa ou
       sobrava, ou encostava o par vizinho.
       ⚠️ Não se mede o carril em píxeis: este desenho acontece quase sempre com
       a gaveta ainda fechada, e aí qualquer medida vem a zero. A percentagem é
       resolvida pelo browser no momento em que a gaveta aparece. */
    var vaoMinimo = 100 / degraus.length;
    var largura = 'clamp(38px, calc(' + vaoMinimo.toFixed(2) + '% - 6px), 76px)';
    degraus.forEach(function (d, i) {
      var on = desbloqueado(d, b);
      var pct = posicao(i);
      /* Sem stock e sem suplente: o ponto e o rótulo ficam apagados e o nome
         leva o sufixo das definições, mesmo que o escalão esteja alcançado. */
      var semOferta = d.esgotado && !d.variante;

      var ponto = document.createElement('span');
      ponto.className = 'cart-degraus__ponto' + (on ? ' is-on' : '') + (semOferta ? ' is-esgotado' : '');
      ponto.style.insetInlineStart = pct + '%';

      /* O ícone vem dos <template> do Liquid: o primeiro degrau é o envio, os
         outros são presentes, e um degrau já alcançado mostra o visto. */
      var molde = on ? tplFeito : (i === 0 ? tplEnvio : tplPresente);
      if (molde && molde.content) ponto.appendChild(molde.content.cloneNode(true));
      pontos.appendChild(ponto);

      /* O rótulo vai para debaixo do SEU ponto, na mesma percentagem que ele.
         Nas pontas o rótulo encosta em vez de centrar, senão saía fora da
         gaveta. */
      var li = document.createElement('li');
      li.className = 'cart-degraus__rotulo' + (on ? ' is-on' : '') + (semOferta ? ' is-esgotado' : '');
      li.style.insetInlineStart = pct + '%';
      li.style.maxWidth = largura;
      if (pct > 88) {
        li.classList.add('is-fim');
      } else if (pct < 12) {
        li.classList.add('is-inicio');
      }
      li.textContent = semOferta ? d.rotulo + ' (' + (c.dataset.textoEsgotado || 'esgotado') + ')' : d.rotulo;
      rotulos.appendChild(li);
    });

    ultimoNo = c;
    ultimaBase = b;
  }

  /* Quando o que falta são artigos DIFERENTES e não dinheiro, o bloco de
     complementares deixa de ser «Também vai gostar...» e passa a ser o caminho
     para o patamar seguinte. Só muda o título; os produtos são os mesmos.
     O título original fica guardado no próprio elemento, para se poder repor
     mal o carrinho mude de estado. */
  function aplicaTituloSugestoes() {
    var el = document.querySelector('[data-js-recomendacoes-titulo]');
    if (!el) return;

    if (!el.dataset.tituloOriginal) el.dataset.tituloOriginal = el.textContent.trim();

    var c = caixa();
    var alternativo = c ? (c.dataset.textoSugestoes || '') : '';
    var novo = (faltaSoProdutos && alternativo) ? alternativo : el.dataset.tituloOriginal;

    if (el.textContent.trim() !== novo) el.textContent = novo;
  }

  /* Há um cupão a valer no carrinho? (29/09/2026)
     O `applicable` da Shopify, sozinho, não serve de árbitro: quando a oferta
     vale mais do que o cupão, a Shopify dá o cupão como NÃO aplicável enquanto
     a oferta estiver no carrinho, e como aplicável assim que ela sai. Decidir
     só por ele deixava cupão e oferta juntos, com a oferta cobrada no
     checkout, e podia pôr a oferta a entrar e a sair.
     Regra: um código conta como cupão se for aplicável, OU se não o for mas só
     por conflito com a oferta. Um código que já não valia com o carrinho SEM
     oferta é inválido (mal escrito, expirado, mínimo por atingir): fica numa
     lista de ignorados e não tira a oferta. Se mais tarde passar a valer, sai
     da lista. */
  var CHAVE_IGNORADOS = 'nvCuponsIgnorados';
  function ignorados() {
    try { return JSON.parse(sessionStorage.getItem(CHAVE_IGNORADOS) || '[]'); } catch (e) { return []; }
  }
  function guardaIgnorados(lista) {
    try { sessionStorage.setItem(CHAVE_IGNORADOS, JSON.stringify(lista)); } catch (e) {}
  }
  function temCupao(carrinho) {
    var lista = (carrinho && carrinho.discount_codes) || [];
    var comOferta = ((carrinho && carrinho.items) || []).some(eOferta);
    var ign = ignorados(), mudou = false, cupao = false;
    lista.forEach(function (d) {
      if (!d || !d.code) return;
      var cod = String(d.code).toUpperCase();
      var i = ign.indexOf(cod);
      if (d.applicable) {
        if (i > -1) { ign.splice(i, 1); mudou = true; }
        cupao = true;
      } else if (!comOferta) {
        if (i === -1) { ign.push(cod); mudou = true; }
      } else if (i === -1) {
        cupao = true;
      }
    });
    if (mudou) guardaIgnorados(ign);
    return cupao;
  }

  /* A recusa guarda-se no localStorage com o token do carrinho: sobrevive a
     mudar de página e a fechar o separador, e morre sozinha quando o carrinho
     acaba (encomenda feita ou carrinho novo), porque o token passa a ser outro. */
  var CHAVE_RECUSA = 'nvOfertaRecusada';
  function leRecusa() {
    try { return JSON.parse(localStorage.getItem(CHAVE_RECUSA) || 'null'); } catch (e) { return null; }
  }
  function guardaRecusa(r) {
    try {
      if (r) localStorage.setItem(CHAVE_RECUSA, JSON.stringify(r));
      else localStorage.removeItem(CHAVE_RECUSA);
    } catch (e) {}
  }
  function recusada(b, variante) {
    var r = leRecusa();
    return !!(r && b && b.carrinho && r.carrinho === b.carrinho && String(r.variante) === String(variante));
  }

  /* O patamar mais alto desbloqueado que tem produto, recusado ou não. */
  function patamarAlcancado(degraus, b) {
    for (var i = degraus.length - 1; i >= 0; i--) {
      if (degraus[i].variante && desbloqueado(degraus[i], b)) return degraus[i];
    }
    return null;
  }

  /* Uma oferta de cada vez: a do patamar MAIS ALTO desbloqueado que tenha
     produto. É o `rewardsRemovePreviousProducts` da app.
     Com cupão no carrinho não há oferta nenhuma: decisão da loja (24/09/2026),
     as ofertas dos patamares e os cupões não se acumulam. */
  function ofertaDevida(degraus, b) {
    if (b && b.cupao) return null;
    var d = patamarAlcancado(degraus, b);
    /* Recusada pelo cliente: não há oferta, nem a do patamar de baixo. */
    if (d && recusada(b, d.variante)) return null;
    return d;
  }

  function sincroniza(degraus, carrinho, b) {
    if (aTratar) return Promise.resolve();
    var devida = ofertaDevida(degraus, b);
    var linhas = (carrinho.items || []).filter(eOferta);

    /* Tudo o que tem de sair: ofertas de outros patamares E duplicados da
       própria (é aqui que o defeito da app deixa de existir). */
    var manter = null, tirar = [];
    linhas.forEach(function (item) {
      var certa = devida && String(item.variant_id) === String(devida.variante);
      if (certa && !manter && item.quantity === 1) { manter = item; return; }
      tirar.push(item.key);
    });

    var juntar = (devida && !manter) ? devida : null;
    if (!tirar.length && !juntar) return Promise.resolve();

    aTratar = true;
    var passos = Promise.resolve();
    tirar.forEach(function (chave) {
      passos = passos.then(function () {
        var body = { updates: {} };
        body.updates[chave] = 0;
        return fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
        });
      });
    });
    if (juntar) {
      passos = passos.then(function () {
        var props = {};
        props[MARCA] = juntar.rotulo;
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: juntar.variante, quantity: 1, properties: props }] })
        });
      });
    }

    /* Mexemos no carrinho por baixo do tema, por isso é preciso pedir-lhe que
       volte a desenhar a gaveta. O `renderHelperCart` é a função que ele usa
       para isso; sem ela, a gaveta ficaria a mostrar o carrinho de antes. */
    return passos
      .then(refrescaGaveta)
      .then(function () { aTratar = false; })
      .catch(function () { aTratar = false; });
  }

  function refrescaGaveta() {
    if (typeof window.renderHelperCart !== 'function') return Promise.resolve();
    return fetch('?section_id=helper-cart')
      .then(function (r) { return r.text(); })
      .then(function (t) { window.renderHelperCart(t); })
      .catch(function () {});
  }

  /* Quantos artigos a gaveta acabou de desenhar, segundo o próprio tema. Serve
     de árbitro: se o `/cart.js` disser outra coisa, um dos dois está atrasado e
     vale a pena voltar a perguntar daqui a pouco. */
  function contagemNaGaveta() {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return null;
    var n = parseInt(el.textContent, 10);
    return isNaN(n) ? null : n;
  }

  function agenda(ms) {
    if (temporizador) clearTimeout(temporizador);
    temporizador = setTimeout(function () {
      temporizador = null;
      atualiza();
    }, ms);
  }

  function atualiza() {
    var c = caixa();
    if (!c) {
      /* Página /cart: não há barra, mas a regra do cupão vale na mesma. Com um
         cupão aplicável no carrinho, as linhas de oferta saem. */
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (carrinho) {
          if (!temCupao(carrinho) || aTratar) return;
          var chaves = (carrinho.items || []).filter(eOferta).map(function (i) { return i.key; });
          if (!chaves.length) return;
          aTratar = true;
          var body = { updates: {} };
          chaves.forEach(function (k) { body.updates[k] = 0; });
          return fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
          }).then(refrescaGaveta).then(function () { aTratar = false; }).catch(function () { aTratar = false; });
        })
        .catch(function () {});
    }
    var degraus = lerDegraus(c);
    if (!degraus.length) return Promise.resolve();

    return carregaExcluidos(c.dataset.excluirColecao || '').then(function (fora) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (carrinho) {
          var b = base(carrinho, fora, c.dataset.contagem);
          desenha(b);

          /* Carregar depressa no «+» deixava a barra um passo atrás: cada
             clique manda a gaveta ser redesenhada, e a conta que se faz aqui
             pode apanhar um carrinho que já mudou outra vez. Enquanto os dois
             lados não disserem o mesmo, volta-se a perguntar. */
          var naGaveta = contagemNaGaveta();
          if (naGaveta !== null && naGaveta !== carrinho.item_count && insistencias < 5) {
            insistencias++;
            agenda(350);
          } else {
            insistencias = 0;
          }

          return sincroniza(degraus, carrinho, b);
        });
    }).catch(function () {});
  }

  /* A gaveta refez-se? O nó é outro. Repõe-se já o desenho com a última conta
     conhecida (para não piscar uma barra vazia) e vai-se confirmar ao servidor. */
  function vigia() {
    var c = caixa();
    if (!c) {
      /* Sem barra (página /cart): o formulário do cupão redesenha o carrinho
         por baixo de nós; espera-se um pouco e aplica-se a regra do cupão. */
      agenda(600);
      return;
    }
    if (c === ultimoNo) return;
    if (ultimaBase) desenha(ultimaBase);
    atualiza();
  }

  /* O botão «Aplicar» do cupão e o «x» que o retira não passam pelos eventos do
     carrinho; escuta-se o clique e dá-se tempo ao pedido antes de reavaliar. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-js-discount-submit], [data-js-discount-remove], .cart__coupons-codes .pill, [data-js-discount]')) agenda(2500);
  }, true);

  /* «Remover» na linha da oferta: guarda a recusa e tira a linha. Na gaveta,
     o motor é que a tira (a oferta deixa de ser devida); na página /cart não
     há motor de ofertas, por isso tira-se aqui e recarrega-se a página. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var bt = e.target.closest('[data-js-oferta-remover]');
    if (bt) {
      e.preventDefault();
      if (aTratar) return;
      bt.disabled = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (carrinho) {
          guardaRecusa({ carrinho: carrinho.token || '', variante: bt.dataset.variante });
          if (caixa()) return atualiza();
          var body = { updates: {} };
          body.updates[bt.dataset.chave] = 0;
          return fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
          }).then(function () { window.location.reload(); });
        })
        .catch(function () { bt.disabled = false; });
      return;
    }
    if (e.target.closest('[data-js-oferta-repor]')) {
      e.preventDefault();
      guardaRecusa(null);
      atualiza();
    }
  }, true);

  var alvo = document.getElementById('AjaxCartForm') || document.body;
  new MutationObserver(vigia).observe(alvo, { childList: true, subtree: true });

  /* O bloco de complementares vive FORA do `#AjaxCartForm`, é carregado por
     AJAX e chega depois desta primeira passagem. Observa-se à parte, senão o
     título só mudava à segunda alteração do carrinho. */
  var caixaSugestoes = document.getElementById('cart-recommendations');
  if (caixaSugestoes) {
    new MutationObserver(function () { aplicaTituloSugestoes(); })
      .observe(caixaSugestoes, { childList: true, subtree: true });
  }

  /* Reagir ao CLIQUE e não só ao redesenho. O «+», o «-» e o «Remover» mudam o
     carrinho por AJAX e a gaveta só é redesenhada no fim; até lá a barra ficava
     parada. Escuta-se na fase de captura, para chegar antes do tema, e espera-se
     um pouco para o servidor já ter a nova quantidade. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var alvo = e.target.closest('.qty-plus, .qty-minus, .remove');
    if (alvo && alvo.closest('#AjaxCartForm')) agenda(450);
  }, true);

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.classList && e.target.classList.contains('qty-selector') && e.target.closest('#AjaxCartForm')) agenda(450);
  }, true);

  /* Rede adicional: o tema abre a gaveta sem mexer no carrinho em certos casos,
     e há temas/apps que disparam estes eventos. Custa nada estar à escuta. */
  ['CartItemAddedEvent', 'CartItemRemovedEvent', 'CartItemUpdatedEvent', 'cart:updated', 'cart:refresh']
    .forEach(function (e) { document.addEventListener(e, function () { atualiza(); }); });

  atualiza();
})();
